// 検索結果を地図上にポリライン・マーカーを描画するコンポーネント
// 検索結果データの削除や排他制御なども担っている
import { useCallback, useEffect } from 'react';

let transitMarkes = []; // 乗り換え案内のmaplibreのmarker
const MapResultRoute = (
  { naviSearch, setNaviSearch, map, isSearchValid, isTablet, style}
) => {
  const REACT_APP_API_BLOCK_URL = process.env.REACT_APP_API_BLOCK_URL
  let naviId = 'navi-route-source';
  let transitIconClassName = "transit-icon";
  let popup = {}

  if(window.maplibregl && window.maplibregl.Popup){
    popup = new window.maplibregl.Popup({
      closeButton: false,
      closeOnClick: false,
      // anchor: 'bottom',
      offset: {
        'top': [0, 17],
        'bottom': [0, -17],
        'left': [15, 0],
        'right': [-15, 0]
      }
    });
  }

  const IMG_BASE_URL = `${REACT_APP_API_BLOCK_URL}/map/uc/RouteImage`;


  const clrearTransitMarker = () => {
    transitMarkes.forEach((marker) => {
      marker.remove();
    });
  }

  const renderRouteImg = ({cross_name,isImg,imgWidth, height,width,imagePath}) => {
    return `<div class="navi-icon-popuup-with-img">
      <div  class='navi-icon-popuup'>
        <div class="navi-icon-popuup-cross-name">
        ${cross_name || ""}
        ${
          isImg
            ? `<div class="navi-icon-popuup-img-wrap" >
                <img src="${imagePath}" height="${height}" width=${width}"  class="navi-icon-popuup-img-background" />
              </div>`
            : ""
        }
      </div>
    </div>`;
  }

  const mapRouteRender = (geojson, type) => {
    mapRouteRemove();

    let {polyLineFeatures, pointFeatures} = geojson;
    // ポリラインの描画
    map.addSource(`${naviId}-polyLine` , {
      type: 'geojson',
      data: {
        type: "FeatureCollection",
        features: polyLineFeatures
      }
    });
    map.addLayer({
      id: naviId + '-layer',
      type: 'line',
      source: `${naviId}-polyLine`,
      layout: {
        'line-join': 'round',
        'line-cap': 'round'
      },
      paint: {
        'line-color': ['get', 'stroke'],
        'line-width': 6,
        'line-opacity': 0.8
      }
    });

    // ポイントの描画
    if(pointFeatures){
      map.addSource(`${naviId}-points` , {
        type: 'geojson',
        data: {
          type: "FeatureCollection",
          features: pointFeatures
        }
      });

      if(type === "transit"){
        // layerで入れようとしたけど、画像をaddImageしないと使えないっぽいので、一旦ボツ
        // map.addLayer({
        //   id: naviId + '-layer-points',
        //   type: 'symbol',
        //   source: `${naviId}-points`,
        //   layout: {
        //     'icon-image': ['get', 'imgSrc'],
        //   },
        // });
        // clrearTransitMarker();

        // imgのsrcを使いたいのでaddLayerせずにmarkerで対処する
        transitMarkes = pointFeatures.map((marker)=>{
          let {properties: {imgSrc, iconSize}} = marker;
          let el = document.createElement('img')
          el.src = imgSrc;
          el.className = transitIconClassName;
          el.style.width = `${iconSize[0]}px`;
          el.style.height = `${iconSize[1]}px`;
          return new window.maplibregl.Marker({element: el})
            .setLngLat(marker.geometry.coordinates)
            .addTo(map);
        });
      }else {
        map.addLayer({
          id: naviId + '-layer-points',
          type: 'circle',
          source: `${naviId}-points`,
          paint: {
            'circle-color': '#fff',
            'circle-radius': 6,
            'circle-stroke-width': 2,
            'circle-stroke-color': '#666'
          },
          
        });
        // ポイントのマウスホバー、タップのハンドラをつける
        map.on("mouseenter", naviId + '-layer-points', popupRender);
        map.on("click", naviId + '-layer-points', popupRender);
        map.on("mouseleave", naviId + '-layer-points', (e)=>{
          popup.remove();
        });
      }

    }

    // 全ラインのpointを見て地図の表示を最適縮尺にする
    let {lats, lons} = polyLineFeatures.reduce((acc, feature)=>{
      let {geometry:{coordinates}} = feature;
      coordinates.forEach(([lon, lat])=>{
        acc.lats.push(lat);
        acc.lons.push(lon);
      });
      return acc;
    }, {lats: [], lons:[]});
    if(lats.length !== 0 && lons.length !== 0){
      let [minlat] = lats.sort();
      let maxLat = lats.sort()[lats.length - 1]
      let [minLon] = lons.sort();
      let maxLon = lons.sort()[lons.length - 1]
      let padding =  {top: 100, left: 500, bottom: 100, right:40};
      if(isTablet){
        padding=  {top: 160, left: 30, bottom: 230, right:80}; // SPの場合は範囲が狭いので余白を変える※上下左右の対象同士の値が画面の範囲を超えると全くうごかなくなるので
      }
      map.fitBounds([[minLon, minlat], [maxLon, maxLat]], {padding});
    }

    setNaviSearch({ ...naviSearch, resultRendered: true });
  }

  const popupRender = (e)=>{
    let {features, lngLat, type} = e;
    let [feature] = features;
    let {properties} = feature;
    let {cross_name, guide_illust, guide_illust_type} = properties;
    cross_name = cross_name !== "{}"? cross_name: ""; // cross_nameが無いときは文字列で "{}"" が返ってくるのでそれで判定する
    let imgWidth = "auto";

    if(type === "click" && popup.isOpen()){
      popup.remove();
    }

    if(guide_illust_type) {
      let img = new Image();
      let imagePath = `${IMG_BASE_URL}?sid=${guide_illust}&img=gif&grp=all`;
      img.onload = ()=>{
        let {height, width} = img;
        imgWidth = width;
        let viewHeight = height < width ? 90 : "auto"; // 横幅のほうが大きい場合は縦を90pxで固定
        let viewWidth = width < height ? 120 : "auto"; // 縦幅の方が大きいと場合は横を120pxで固定
        if(isTablet){ // SP表示の場合はサイズを小さくする
          viewHeight = height < width ? 60 : "auto";
          viewWidth = width < height ? 90 : "auto";
        }

        let html = renderRouteImg({
          cross_name,
          isImg: true,
          imgWidth,
          height: viewHeight,
          width: viewWidth,
          imagePath
        })
        popup.setLngLat(lngLat).setMaxWidth(`${imgWidth}px`).setHTML(html).addTo(map);
      }
      img.src = imagePath;

    } else if(cross_name !== "" && !guide_illust_type){ // 画像なしで交差点名ありの場合 ※交差点名がない場合は文字列で "{}" になる
      popup.setLngLat(lngLat).setHTML(renderRouteImg({cross_name, isImg: false, imgWidth})).addTo(map);
    } else {
      // 画像もなく交差点名がない場合はポップアップを表示しない
    }
  }

  const mapRouteRemove = () => {
    if (map.getLayer(naviId + '-layer')) map.removeLayer(naviId + '-layer');
    if (map.getLayer(naviId + '-layer-points')) map.removeLayer(naviId + '-layer-points');
    if (map.getSource(`${naviId}-polyLine`)) map.removeSource(`${naviId}-polyLine`);
    if (map.getSource(`${naviId}-points`)) map.removeSource(`${naviId}-points`);
    clrearTransitMarker();
  }

  // 基本的にtypeのデータのみ残して、その他typeのデータは削除する
  const deleteTargetOtherData = ()=>{
    let {driveResult, walkResult, transitResult, type} = naviSearch;
    driveResult = type === "drive" && driveResult? driveResult: null;
    walkResult = type === "walk" && walkResult? walkResult: null;
    transitResult = type === "transit" && transitResult? transitResult: null;
    setNaviSearch({ ...naviSearch, driveResult, walkResult, transitResult, resultRendered: false });
  }

  const allDeleteData = () => {
    setNaviSearch({ ...naviSearch, driveResult: null, walkResult: null, transitResult: null, resultRendered: false });
  }

  
  // データを消す条件: typeに対して他のデータがある場合はmapRouteRemoveして地図描画もデータも空にする
  // 上記のデータ変更で再びこのmapRenderRouteに再帰して以降のelse ifの構文が実行される
  let {type, driveResult, walkResult, transitResult, resultRendered} = naviSearch
  if(
    (isSearchValid && type === "walk" && (driveResult || transitResult)) ||
    (isSearchValid && type === "drive" && (walkResult || transitResult)) ||
    (isSearchValid && type === "transit" && (driveResult || walkResult))
  ){
    mapRouteRemove();
    deleteTargetOtherData();
    // return null;
  // 検索結果があって、地図上にポリラインが表示されてないときは描画する
  } else 
  if(driveResult && !resultRendered) {
    mapRouteRender(driveResult);
  } else if(walkResult && !resultRendered) {
    mapRouteRender(walkResult);
  } else if(transitResult && !resultRendered) {
    mapRouteRender(transitResult, "transit");
  // 検索条件が無効になり、かつ、ルートデータが存在したらルート表示を消して結果データをすべて消す
  }else if(!isSearchValid && resultRendered){
    mapRouteRemove();
    allDeleteData();
  }

  // 地図のレイヤースタイルが変更された時の処理
  // ※なんでこんなことするかと言うとmap.setStyle()するとポリラインのlayerが削除されてしまうmapLibre仕様なのでLayerを再描画する
   /* eslint-disable react-hooks/exhaustive-deps */
  const rerenderMapPolyLine = useCallback(() => {
    if (style && map) {
      // スタイル適用後にポリラインなどのレイヤーを再描画
      map.once('idle', () => {
        setNaviSearch({ ...naviSearch, resultRendered: false }); // resultRenderedフラグを落として次の再帰でLayerの再描画する
      });
    }
  }, [style, map]);  /* eslint-enable react-hooks/exhaustive-deps */ //naviSearchをuseCallbackに設定するとレンダリングが止まらなくなるので、一旦eslintの警告を解除させる
 
  useEffect(() => {
    rerenderMapPolyLine();
  }, [rerenderMapPolyLine]);

  return null;
}

export default MapResultRoute;